<script setup>
import { computed } from "vue";
import { useLayoutStore } from "@/stores/layoutStore.js";

const layoutStore = useLayoutStore();

const isWebMobile = computed(() => {
  return layoutStore.isMobileSize;
});
</script>

<template>
  <div v-if="layoutStore.showBottomToast === true" class="toast-box">
    <div
      class="toast mx-[18px] box-shadow flex gap-[8px] items-center"
      :class="isWebMobile ? '' : ''"
    >
      <img src="@/assets/icons/ic_point_blue.svg" class="size-[18px]" /><span
        class="label_6"
        >{{ layoutStore.bottomToast?.detail }}</span
      >
    </div>
  </div>
</template>

<style scoped>
.toast-box {
  position: absolute;
  bottom: 112px;
  left: calc((100% - 520px) / 2);
  right: calc((100% - 520px) / 2);
  width: 100vw;
  max-width: 520px;
  /* height: 100vh; */
  z-index: 999;
}
@media screen and (width < 520px) {
  .toast-box {
    position: absolute;
    bottom: 112px;
    left: 0;
    width: 100vw;
    max-width: 520px;
    /* height: 100vh; */
    z-index: 999;
  }
}
.toast {
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--G650, #5b5f68);
  border: 1px solid var(--g-28012, rgba(204, 213, 226, 0.12));
  height: 52px;
  color: var(--White, #fff);
}
.box-shadow {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
}
</style>
